import { memo, useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Checkbox, Radio, RadioGroup, TextField } from 'basic-components';
import { CommonService } from 'dashboard-services/services';

import './Hour.scss';

const HOURLY = {
  EXACTLY_AT: "EXACTLY_AT",
  EVERY_HOUR: "EVERY_HOUR",
  EVERY_X_HOURS: "EVERY_X_HOURS"
}
const getSelectedHourly = hour => {
  if(String(hour).indexOf("/") > -1) {
    return HOURLY.EVERY_X_HOURS;
  } else if(String(hour) === "*") {
    return HOURLY.EVERY_HOUR;
  } else {
    return HOURLY.EXACTLY_AT;
  }
}

const getEveryHour = hour => {
  if(String(hour).startsWith("0/")) {
    return String(hour).slice(2)
  }
  return ""
}


const Hour = ({ hour = "", setHour }) => {
  const [selectedHourly, setSelectedHourly] = useState(() => getSelectedHourly(hour)),
        onChangeExactHour = useCallback(selected => {
          const splittedHour = hour === "*" || hour === "" || hour.indexOf("/") > -1 ? [] : String(hour).split(",")
          if(splittedHour.indexOf(String(selected)) > -1) {
            const newHour = splittedHour.remove(splittedHour.indexOf(String(selected))).join(",")
            setHour(newHour)
          } else {
            const newHour = splittedHour.add(selected).join(",")
            setHour(newHour)
          }
        }, [hour, setHour]),
        onChangeSelectedHourly = useCallback(value => value && setSelectedHourly(value), []),
        onClickEveryHour = useCallback(() => setHour("*"), [setHour]),
        onChangeEveryXHours = useCallback(value => value !== "" && CommonService.isNumber(value) && setHour(`0/${value}`), [setHour])

  useEffect(() => {
    setSelectedHourly(getSelectedHourly(hour))
  }, [hour])

  return (
    <div className="cron-creator__body__hour">
      <RadioGroup
          name="hourly"
          onChange={onChangeSelectedHourly}
          selectedValue={selectedHourly}
      >
        <Radio name={HOURLY.EXACTLY_AT}>
          Exactly at
        </Radio>
        <div className="cron-creator__body__at">
          {[...Array(24).keys()].map(index => (
            <Checkbox
                checked={String(hour).split(",").includes(String(index)) && hour !== "*"}
                key={index}
                onChange={() => onChangeExactHour(index)}
            >
              {('0' + String(index)).slice(-2)}
            </Checkbox>
          ))}
        </div>
        <Radio 
            name={HOURLY.EVERY_HOUR}
            onClick={onClickEveryHour}
        >
          Every hour
        </Radio>
        <Radio name={HOURLY.EVERY_X_HOURS}>
          <div className="cron-creator__body__every-x">
            <p>Every</p>
            <TextField
                defaultValue={getEveryHour(hour)}
                name="everyXHour"
                noError
                onChange={onChangeEveryXHours}
                variant="border"
            />
            <p>hours</p>
          </div>
        </Radio>
      </RadioGroup>
    </div>
  )
}

Hour.propTypes = {
  hour: PropTypes.string,
  setHour: PropTypes.func.isRequired
}

export default memo(Hour);